import React from 'react';
import styled from 'styled-components';
import logo from '../assets/images/DAICB logo.png';
import { FaMedium, FaTwitter, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <div className="container">
        <FooterContent>
          <FooterLeft>
            <FooterText>
              Personalized AI coaching for business professionals who want practical, actionable strategies.
            </FooterText>
            <SocialIcons>
              <a href="https://rizpabani.medium.com/" target="_blank" rel="noopener noreferrer"><FaMedium /></a>
              <a href="https://x.com/rizpabani" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
              <a href="https://www.linkedin.com/in/rizpabani/" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
            </SocialIcons>
            <FooterLinks>
              <a href="/terms-of-use">Terms of Service</a>
              <a href="/privacy-policy">Privacy Policy</a>
            </FooterLinks>
            <Copyright>
              &copy; {currentYear} Dreams AI Can Buy. All rights reserved.
            </Copyright>
          </FooterLeft>
          <LogoContainer>
            <img src={logo} alt="Dreams AI Can Buy Logo" />
          </LogoContainer>
        </FooterContent>
      </div>
    </FooterContainer>
  );
};

const FooterContainer = styled.footer`
  background-color: #1a1a2e;
  color: var(--white);
  padding: 3rem 0;
`;

const FooterContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

const FooterLeft = styled.div`
  max-width: 600px;
`;

const FooterText = styled.p`
  margin-bottom: 1rem;
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 1rem;
  font-size: 1.5rem;
  margin-bottom: 1rem;

  a {
    color: var(--white);
    transition: color 0.3s;

    &:hover {
      color: var(--primary-color);
    }
  }
`;

const FooterLinks = styled.div`
  display: flex;
  gap: 1rem;

  a {
    color: var(--white);
    text-decoration: none;
    transition: color 0.3s;

    &:hover {
      color: var(--primary-color);
    }
  }
`;

const LogoContainer = styled.div`
  img {
    height: 50px;
    filter: brightness(0) invert(1);
  }
`;

const Copyright = styled.p`
  margin-top: 1rem;
  font-size: 0.9rem;
  opacity: 0.8;
`;

export default Footer;
